






























import Enumerable from "linq";
import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { StandardOption, MultiOptionSelectableMixin } from "./mixins";
import { BrowserUtility, BrowserKinds } from "../../../utilities";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class MultiOptionListBoxSelector extends Mixins(MultiOptionSelectableMixin) {
  // TODO Firefox対応時にホイールでスクロール量減少問題があったためselectタグを使用しない実装を検討する
  @Prop({default: 50 })
  loadChunkSize: number;

  /**
   * ひとつしか選択されていない状態で、その項目をクリックしたときにクリアするかどうか
   */
  @Prop({default: false })
  isInstantClearable: boolean;

  data(): any {
    return {
      chunkedCount: 0,
      preferredCount: 0,
      loadOptions: [],
      loadedOptions: [],
      infiniteLoading: null,
      preSelectedOptions: [],
    };
  }
  chunkedCount: number;
  preferredCount: number;
  loadOptions: StandardOption<any>[];
  loadedOptions: any[];
  infiniteLoading: InfiniteLoading;
  preSelectedOptions: StandardOption<any>[];

  created() {
    this.$logger.debug("MultiOptionListBoxSelector created.");
  }

  mounted(): void {
    this.$logger.debug("MultiOptionListBoxSelector mounted.");
    this.infiniteLoading = this.$refs.infiniteLoading as InfiniteLoading;
  }

  beforeUpdate() {
    this.$logger.debug("MultiOptionListBoxSelector beforeUpdate.");
  }

  updated() {
    this.$logger.debug("MultiOptionListBoxSelector updated.");
  }

  updateLoadOptions(): void {
    const options = this.filteredOptions.slice();
    const preferredOptions = [] as StandardOption<any>[];
    Enumerable.from(this.selectedOptions).forEach(e => {
      for (let i = 0; i < options.length;) {
        if (this.areEqual(e.value, options[i].value)) {
          preferredOptions.push(options.splice(i, 1)[0]);
          continue;
        }
        i++;
      }
    });
    this.preferredCount = preferredOptions.length;
    this.loadOptions = preferredOptions.concat(options);
  }

  onInfinite(): void {
    this.$logger.debug("onInifinite");
    this.chunkList();
  }

  private chunkList(): void {
    if (this.chunkedCount === 0) {
      this.updateLoadOptions(); // resetChunkList()で呼び出すとInfiniteLoadingがうまく動作しない
    }
    const maxLoadSize = (this.chunkedCount === 0 && this.loadChunkSize < this.preferredCount)
      ? this.preferredCount
      : this.loadChunkSize;
    for (let i = this.chunkedCount; i < (this.chunkedCount + maxLoadSize); i++) {
      if (i >= this.loadOptions.length) {
        this.$logger.debug("call complete. i is " + i);
        this.infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedOptions.push(this.loadOptions[i]);
    }
    this.chunkedCount += maxLoadSize;

    this.$logger.debug("call loaded. chunkedCount is " + this.chunkedCount);
    this.infiniteLoading.stateChanger.loaded();
  }

  wheelSelect(e: WheelEvent): void {
    // Firefoxでスクロール量が少なくなるための対策
    // selectタグのイベントで発生したスクロール量が親のdivのスクロールに影響している模様
    // スクロール量は行単位(DeltaMode=1)でdeltaY=2.5を指していたが、ピクセル単位でスクロールしているように見える。
    // selectタグでスクロールイベントを親に通知しないことで対策した。
    // ブラウザチェックをしているのはIEでは動作しなくなるため。
    if (BrowserUtility.getBrowserKind() === BrowserKinds.MozillaFirefox) {
      e.stopPropagation();
    }
  }

  wheel(e: WheelEvent): void {
    // IEでselectタグにフォーカスがある場合スクロールが行われないので手動で制御
    e.preventDefault();
    if (e.currentTarget instanceof HTMLDivElement) {
      e.currentTarget.scrollLeft += e.deltaX;
      e.currentTarget.scrollTop += e.deltaY;
    }
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    // 選択状態を更新
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => this.optionFilter(o))
      .toArray();
  }

  // ローディング状態をリセット
  resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;

    if (this.infiniteLoading) {
      this.$logger.debug("call reset.");
      this.infiniteLoading.stateChanger.reset();
    }
  }

  @Emit()
  keyup(e: KeyboardEvent): void {}

  @Emit()
  keydown(e: KeyboardEvent): void {}

  // optionのclickイベントはIEでは動作しない...(chromeはイケた.)回避策として選択変更時に増えてる物をクリックされたと見なす.
  @Watch("selectedOptions")
  onSelectedOptions(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    this.notifyClicked(newValue, oldValue);
  }

  private notifyClicked(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    if (newValue.length === 0) { return; }
    if (oldValue.length > 0 && newValue.length > oldValue.length) {
      const multipleLastClicked = Enumerable.from(newValue).firstOrDefault(o => (oldValue.indexOf(o) < 0));
      this.clicked(multipleLastClicked.value);
      return;
    }
    this.clicked(newValue[newValue.length - 1].value); 
  }

  @Emit()
  clicked(clicked: any): void {}

  dblclick(e: PointerEvent): void {
    // クリックでのクリア機能を有効にしたときはダブルクリックするとクリアされるので無効にしている
    if (this.isInstantClearable) {
      return;
    }
    // フィルタで0件になってもselectタグは2行分の領域があるためイベントが発生してしまう
    // また、その際フィルタ以前に選択した状態が維持されるため、そのまま選択されてしまう
    // そのためフィルタが更新された際、範囲外の場合選択状態を解除し、ダブルクリックでは未選択は通知を行わない
    if (this.selectedOptions === null || this.selectedOptions.length === 0) {
      return;
    }
    this.$emit("dblclick", e);
  }

  onSelectMousedown(): void {
    // IEとChromeでclickイベントの発生するタイミングとbindされた値が更新されるタイミングが異なるので、
    // clickイベントの前にあらかじめ前回値を記憶しておく
    this.preSelectedOptions = this.selectedOptions;
  }

  onSelectClick(): void {
    if (!this.isInstantClearable) {
      return;
    }
    this.$nextTick(() => {
      // ひとつしか選択されていない状態で、その項目をクリックしたとき
      if (this.preSelectedOptions.length === 1 && this.selectedOptions.length === 1 && this.preSelectedOptions[0] === this.selectedOptions[0]) {
        this.selectedOptions = [];
      }
    });
  }
}
